module.exports = __webpack_public_path__ + "static/idas-sm-0117eaf5e70cd634766188fa8d3f9624.jpg";